$ = window.jQuery = require 'jquery'
_ = require 'lodash'
# Redirect     = require '../../../requires/pc/redirect'
Elements     = require '../../../requires/pc/elements'
Anchor       = require '../../../requires/pc/ui/anchor'
# FlatHeight   = require '../../../requires/pc/ui/flat-height'
# MenuNav      = require '../../../requires/pc/ui/menu-nav'
# ScrollAnime  = require '../../../requires/pc/ui/scroll-animation'
# TabHover     = require '../../../requires/pc/ui/tab-hover'
# SectionHover = require '../../../requires/pc/ui/section-hover'
# Slider       = require '../../../requires/pc/ui/slider'
# YouTube      = require '../../../requires/pc/ui/youtube'
require 'velocity/velocity.min'

###
multiple new class
###
newClass = (className, el, opts) ->
  $ el
    .each ({}, _el) ->
      if opts
        new className _el, opts
      else
        new className _el

###
single new class
###
newClassSingle = (className, el, opts) ->
  $el = $ el
  if $el.size()
    if opts
      new className el, opts
    else
      new className el

$ document
  .one 'ready', ->
    new Elements
    # _.forEach [
    #   [ FlatHeight     , '.js-flat-height', { column: 3 } ]
    #   [ MenuNav        , '.js-menu-wrap' ]
    #   [ YouTube        , '.js-youtube' ]
    # ], (arr) ->
    #   newClassSingle.apply @, arr
    _.forEach [
      [ Anchor , 'a[href^="#"]' ]
      # [ ScrollAnime, '.js-scroll-anime' ]
      # [ TabHover, '.js-tab-hover-wrap']
      # [ SectionHover, '.js-section-hover']
      # [ Slider , '.js-slider-keyvisual',
      #   slickOpts:
      #     arrows        : false
      #     dots          : true
      #     infinite      : true
      #     speed         : 500
      #     autoplay      : true
      #     autoplaySpeed : 5000
      #     slidesToShow  : 1
      #     centerPadding : 0
      #     centerMode    : true
      #     # variableWidth : true
      # ]
    ], (arr) ->
      newClass.apply @, arr



/** WEBPACK FOOTER **
 ** ./webpack/src/contents/scripts/index.coffee
 **/